// 24 Oct 2026 (Nas, page weight): moved out of snippets/adore-grid-style.liquid so the browser can cache it. Code unchanged.
  /* 9 Oct 2026 (Yass, panel: size pages opened on sold-out rugs). Collection and search grids now show rugs that are in
     stock first, then rugs sold out in the size this page is about ("Sold out in this size"), then rugs sold out in every
     size. In-stock rugs are shuffled once a day (same order all day, so Back and paging stay stable). If the shopper picks a
     sort order (price, newest...), that order is kept and only the sold-out rugs move to the end. Re-runs when filters
     reload the grid. */
  (function(){
    function h(s){var x=2166136261;for(var i=0;i<s.length;i++){x^=s.charCodeAt(i);x=Math.imul(x,16777619);}return x>>>0;}
    function sortGrid(){
      var g=document.getElementById('CollectionProductGrid');
      if(!g||g.getAttribute('data-adore-sorted'))return;
      g.setAttribute('data-adore-sorted','1');
      var cols=[].filter.call(g.children,function(c){return c.querySelector('.product-collection');});
      if(cols.length<2)return;
      var keep=/[?&]sort_by=/.test(location.search), day=String(Math.floor(Date.now()/864e5));
      var items=cols.map(function(c,i){
        var allOut=!!c.querySelector('[data-availability="false"]');
        var sizeOut=!!c.querySelector('.adore-card__out');
        var a=c.querySelector('a[href*="/products/"]'), key=(a?a.getAttribute('href').split('?')[0]:String(i))+day;
        return {c:c,tier:allOut?2:(sizeOut?1:0),r:keep?i:h(key),i:i};
      });
      items.sort(function(x,y){return x.tier-y.tier||(x.tier===0?x.r-y.r:x.i-y.i);});
      items.forEach(function(it){g.appendChild(it.c);});
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sortGrid);else sortGrid();
    var host=document.getElementById('main-collection-product-grid');
    if(host&&window.MutationObserver)new MutationObserver(sortGrid).observe(host,{childList:true,subtree:true});
  })();
  (function(){
    /* 10 Oct 2026 (Yass: All Rugs filtered by size showed rugs sold out in that size among the first ones). Picking one size
       in the All Rugs Size filter opens that size's own page, which lists every rug in stock in that size first, across all
       pages. Other filters the shopper picked are kept. Sizes without their own page (100x400 runner, 140x200) stay here. */
    var M={'80x150cm Runner':'runner-1-5m','80x300cm Runner':'runner-3m','100x300cm Runner':'runner-3m','120x170cm':'small-rugs','160x230cm':'160-x-230','200x290cm':'large-rugs','240x340cm':'extra-large-rugs','280x380cm':'300-x-400','300x400cm':'300-x-400','120x120cm Round':'round-rugs-1','160x160cm Round':'round-rugs-1','200x200cm Round':'round-rugs-1'};
    var K='filter.p.m.custom.rug_size';
    function go(){
      if(!/^\/collections\/all-rugs\/?$/.test(location.pathname))return false;
      var p=new URLSearchParams(location.search),v=p.getAll(K);
      if(!v.length)return false;
      var t=v.map(function(x){return M[x]||'';});
      for(var i=0;i<t.length;i++){if(!t[i]||t[i]!==t[0])return false;}
      p.delete(K);p.delete('page');
      var q=p.toString();
      location.replace('/collections/'+t[0]+(q?'?'+q:''));
      return true;
    }
    if(go())return;
    ['pushState','replaceState'].forEach(function(n){
      var o=history[n];
      history[n]=function(){var r=o.apply(this,arguments);setTimeout(go,0);return r;};
    });
    window.addEventListener('popstate',go);
  })();
  (function(){
    /* phones: clamp the collection description and add a Read more button */
    if(window.innerWidth>767) return;
    var d=document.querySelector('.collection-description-top'); if(!d) return;
    if(d.getAttribute('data-adore-rm')) return; /* 22 Oct 2026: already done early by adore-head-cls */
    var lh=parseFloat(getComputedStyle(d).lineHeight)||22;
    if(d.scrollHeight<=lh*5) return;
    d.classList.add('adore-clamp');
    var b=document.createElement('button'); b.type='button'; b.className='adore-readmore'; b.textContent='Read more';
    b.addEventListener('click',function(){ var open=d.classList.toggle('adore-clamp'); b.textContent=open?'Read more':'Show less'; });
    d.parentNode.insertBefore(b,d.nextSibling);
  })();
